'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');

var alertStyle = {
  success: {
    icon: "check",
    color: {
      icon: settings.COLOR.green,
      text: settings.COLOR.darkGreen,
      background: settings.COLOR.greenPale
    }
  },
  warning: {
    icon: "warning",
    color: {
      icon: settings.COLOR.darkYellowBrighter,
      text: settings.COLOR.darkYellowBrighter,
      background: settings.COLOR.yellowPale
    }
  },
  error: {
    icon: "error",
    color: {
      icon: settings.COLOR.softRed,
      text: settings.COLOR.softRed,
      background: settings.COLOR.redPale
    }
  },
  info: {
    icon: "info",
    color: {
      icon: settings.COLOR.deepBlue,
      text: settings.COLOR.deepBlue,
      background: settings.COLOR.deepBluePale
    }
  },
  suggest: {
    icon: "MenuSuggest",
    color: {
      icon: settings.COLOR.textBlack,
      text: settings.COLOR.textBlack,
      background: settings.COLOR.veryLightGray
    }
  },
  "info-gray": {
    icon: "info",
    color: {
      icon: settings.COLOR.textBlack,
      text: settings.COLOR.textBlack,
      background: settings.COLOR.veryLightGray
    }
  }
};

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  position: relative;\n  padding: ", ";\n  margin: ", ";\n  letter-spacing: normal;\n  ", ";\n  border-radius: ", ";\n  color: ", ";\n  background: ", ";\n  width: ", ";\n  ", ";\n  @media (max-width: 991px) {\n    width: 100%;\n    border-radius: ", ";\n    ", ";\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  position: relative;\n  padding: ", ";\n  margin: ", ";\n  letter-spacing: normal;\n  ", ";\n  border-radius: ", ";\n  color: ", ";\n  background: ", ";\n  width: ", ";\n  ", ";\n  @media (max-width: 991px) {\n    width: 100%;\n    border-radius: ", ";\n    ", ";\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  cursor: pointer;\n  width: 12px;\n  height: 12px;\n"], ["\n  cursor: pointer;\n  width: 12px;\n  height: 12px;\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n"], ["\n  width: 20px;\n  height: 20px;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  width: 100%;\n  margin: ", ";\n  font-size: 14px;\n  font-style: normal;\n  line-height: 20px;\n"], ["\n  width: 100%;\n  margin: ", ";\n  font-size: 14px;\n  font-style: normal;\n  line-height: 20px;\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  font-weight: normal;\n"], ["\n  font-weight: normal;\n"]);

var StyleAlert = styled__default.div(_templateObject, function (props) {
  return props.padding || "10px 10px";
}, function (props) {
  return props.margin || "10px 0px 0px";
}, function (props) {
  return props.border && "border: " + props.border;
}, function (props) {
  return props.noneBorderRadius ? "0px" : "8px";
}, function (props) {
  return props.statusColor && props.statusColor.text ? props.statusColor.text : settings.COLOR.bgGray;
}, function (props) {
  return props.statusColor && props.statusColor.background ? props.statusColor.background : settings.COLOR.darkGray;
}, function (props) {
  return props.width ? "" + props.width : "100%";
}, function (props) {
  return props.height && "height: " + props.height;
}, function (props) {
  return props.noneBorderRadiusMobile ? "0px" : "8px";
}, function (props) {
  return props.mMargin && "margin: " + props.mMargin;
});

var CloseBtn = styled__default.div(_templateObject2);
var IconContainer = styled__default.div(_templateObject3);
var MessageStyle = styled__default.div(_templateObject4, function (props) {
  return props.margin || "0px 10px";
});

var MessageTitleStyle = styled__default.div(_templateObject5);

var MessageBodyStyle = styled__default.div(_templateObject6);

var Panel = function Panel(_ref) {
  var _ref$status = _ref.status,
      status = _ref$status === undefined ? "info" : _ref$status,
      titleMessage = _ref.titleMessage,
      bodyMessage = _ref.bodyMessage,
      onClose = _ref.onClose,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === undefined ? false : _ref$hideCloseButton,
      _ref$hideIcon = _ref.hideIcon,
      hideIcon = _ref$hideIcon === undefined ? false : _ref$hideIcon,
      children = _ref.children,
      closeIconColor = _ref.closeIconColor,
      restProps = _babelHelpers.objectWithoutProperties(_ref, ["status", "titleMessage", "bodyMessage", "onClose", "hideCloseButton", "hideIcon", "children", "closeIconColor"]);
  var _alertStyle$status = alertStyle[status],
      icon$1 = _alertStyle$status.icon,
      color = _alertStyle$status.color;

  return React__default.createElement(
    StyleAlert,
    _babelHelpers._extends({ statusColor: color }, restProps),
    !hideIcon && React__default.createElement(
      IconContainer,
      null,
      React__default.createElement(icon.Icon, { name: icon$1, size: "lg", color: color.icon })
    ),
    React__default.createElement(
      MessageStyle,
      { margin: restProps.messageMargin },
      React__default.createElement(
        MessageTitleStyle,
        null,
        titleMessage
      ),
      bodyMessage && React__default.createElement(
        MessageBodyStyle,
        null,
        bodyMessage
      ),
      children
    ),
    !hideCloseButton && React__default.createElement(
      CloseBtn,
      { id: "closeAlert", onClick: onClose },
      React__default.createElement(icon.Icon, { name: "close", size: "sm", color: closeIconColor })
    )
  );
};
Panel.propTypes = {
  /** status of the panel. The panel color and style will depend on this status */
  status: PropTypes$1.string.isRequired,
  /** Title message */
  titleMessage: PropTypes$1.string,
  /** Body message  */
  bodyMessage: PropTypes$1.string,
  /** function when click close button  */
  onClose: PropTypes$1.func,
  /** Hide close button */
  hideCloseButton: PropTypes$1.bool,
  /** Children element */
  children: PropTypes$1.element,
  /** Set the border radius to 0px */
  noneBorderRadius: PropTypes$1.bool,
  /** Set the border radius to 0px on mobile */
  noneBorderRadiusMobile: PropTypes$1.bool,
  /** A padding of the panel, default is 10px 10px */
  padding: PropTypes$1.string,
  /** A margin of the panel, default is 10px 0px 0px */
  margin: PropTypes$1.string,
  /** A height of the panel, default is unset (no height) */
  height: PropTypes$1.string,
  /** A border of the panel, default is unset (no border) */
  border: PropTypes$1.string,
  /** A margin of MessageStyle component */
  messageMargin: PropTypes$1.string,
  /** Color of close icon */
  closeIconColor: PropTypes$1.string
};
Panel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Panel",
  "props": {
    "status": {
      "defaultValue": {
        "value": "\"info\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "status of the panel. The panel color and style will depend on this status"
    },
    "hideCloseButton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hide close button"
    },
    "hideIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "titleMessage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Title message"
    },
    "bodyMessage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Body message"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function when click close button"
    },
    "children": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": "Children element"
    },
    "noneBorderRadius": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set the border radius to 0px"
    },
    "noneBorderRadiusMobile": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set the border radius to 0px on mobile"
    },
    "padding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A padding of the panel, default is 10px 10px"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A margin of the panel, default is 10px 0px 0px"
    },
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A height of the panel, default is unset (no height)"
    },
    "border": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A border of the panel, default is unset (no border)"
    },
    "messageMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A margin of MessageStyle component"
    },
    "closeIconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Color of close icon"
    }
  }
};

exports.CloseBtn = CloseBtn;
exports.IconContainer = IconContainer;
exports.MessageBodyStyle = MessageBodyStyle;
exports.MessageStyle = MessageStyle;
exports.MessageTitleStyle = MessageTitleStyle;
exports.Panel = Panel;
exports.StyleAlert = StyleAlert;
exports.default = Panel;
//# sourceMappingURL=panel.js.map
